import React from 'react';
import { Group, Switch, Badge } from '@landr/maestro';
import { t } from '@lingui/macro';
import { useUpsellActionsContext } from '../../context/UpsellActionsContext';

const FrequencySwitch = () => {
    const {
        yearlySaving,
        hasSale,
        showYearly,
        handleFrequencyChange,
        showFrequencySwitch,
    } = useUpsellActionsContext();

    if (!showFrequencySwitch) {
        return null;
    }

    return (
        <Group.Item alignSelf="center">
            <Group direction="horizontal" alignItems="center">
                <Switch
                    isOn={showYearly}
                    size="md"
                    onLabel={t`Yearly`}
                    offLabel={t`Monthly`}
                    onChange={handleFrequencyChange}
                />
                {!hasSale && (
                    <Badge
                        size="sm"
                        variant="warning"
                        kind="subtle"
                        content={t`SAVE ${yearlySaving}%`}
                        ml="xs"
                    />
                )}
            </Group>
        </Group.Item>
    );
};

export default FrequencySwitch;
